import { render, staticRenderFns } from "./Jgxx.vue?vue&type=template&id=49ce389e&scoped=true"
import script from "./Jgxx.vue?vue&type=script&lang=js"
export * from "./Jgxx.vue?vue&type=script&lang=js"
import style0 from "./Jgxx.vue?vue&type=style&index=0&id=49ce389e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ce389e",
  null
  
)

export default component.exports